
import React, {useState} from "react";
import {IconButton, InputAdornment} from "@mui/material";
import RayaField from "./RayaField";
import {Eye, EyeOff} from "lucide-react";


export default function PassField(props) {
    const [visible, setVisible] = useState(false);

    return (
        <>
            <RayaField
                {...props}
                type={visible ? "text" : "password"}
                InputProps={{
                    endAdornment:(
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                edge="end"
                                onClick={() => setVisible(!visible)}
                            >
                                {visible ? <Eye className="lucide-icon"/> : <EyeOff className="lucide-icon" />}
                            </IconButton>
                        </InputAdornment>
                        )
                }}

            />
        </>
    );
}